import React from 'react';
import { FileText } from 'lucide-react';

const ProvozniRad = () => {
  const rules = [
    'Zájemci o táboření nebo stanování jsou povinni svůj pobyt nahlásit u stánku s občerstvením. Zde jim obsluha sdělí, za jakých podmínek mohou tábořit.',
    null, // Pravidlo 2 - speciální, s červeným zvýrazněním (renderováno samostatně)
    'Rozdělávání ohně je povoleno pouze na ohništích zřízených a schválených provozovatelem. Ohniště je možno užívat jen za přísného dodržování požární bezpečnosti.',
    'Není dovoleno upravovat terén, poškozovat stromy, zeleň a poškozovat zařízení a majetek provozovatele.',
    'Návštěvník bere na vědomí, že zařízení areálu např. prolézačky, pískoviště, houpačky smí být užívány pouze k činnostem, ke kterým jsou určeny. Rodič nebo zákonný zástupce dítěte je povinen dohlížet a dbát na to, aby dítě dodržovalo bezpečnost na všech zařízeních v areálu.',
    'Není povolen prodej zboží, poskytování služeb a provozování jakékoli komerční činnosti bez souhlasu provozovatele tábořiště.',
    'Při pobytu je návštěvník povinen udržovat pořádek. Na odpadky užívejte popelnice a třiďte odpad!',
    null, // Pravidlo 8 - "zakázáno" červeně
    null, // Pravidlo 9 - čas červeně
    'Obzvláště hrubé nebo agresivní jednání návštěvníka areálu bude považováno za závažné porušení organizačně provozního řádu a opravňuje zástupce provozovatele k jeho bezodkladnému vyloučení a ukončení dalšího pobytu.',
  ];

  return (
    <section className="py-16 px-4 bg-white min-h-screen" data-testid="provozni-rad-section">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <FileText className="w-16 h-16 mx-auto text-blue-600 mb-4" />
          <h2 className="text-4xl font-bold text-gray-800 mb-2">Provozní řád</h2>
          <p className="text-xl text-gray-600 font-semibold uppercase tracking-wider mt-2">
            Organizačně provozní řád
          </p>
        </div>

        <div className="bg-gray-50 rounded-xl p-8 shadow-sm">
          {/* Úvod */}
          <div className="mb-8 space-y-4 text-gray-800 leading-relaxed">
            <p className="text-lg font-semibold">Vážení hosté</p>
            <p>
              Před začátkem pobytu se prosím seznamte s tímto organizačně provozním řádem.
              Do prostoru tábořiště vjíždějte jen, jste-li srozuměni s jednotlivými body tohoto řádu.
            </p>
            <p className="font-semibold">
              Skupiny do 15 osob si nemusí zajišťovat rezervace. <span className="text-gray-600">(kromě termínu 5. - 7.7.)</span>
            </p>
          </div>

          <div className="border-t border-gray-300 pt-8 space-y-5 text-gray-800 leading-relaxed">
            {/* 1) */}
            <p>
              <span className="font-bold">1)</span> {rules[0]}
            </p>

            {/* 2) - speciální s červeným zvýrazněním */}
            <div>
              <p>
                <span className="font-bold">2)</span> Vjezd vozidel do areálu tábořiště (porušení zákazu vjezdu) je povolen pouze pro vyložení a naložení věcí pro pobyt a táboření na dobu 15 minut. Čas příjezdu do areálu bude zaznačen na pásku na ruku.
                Po naložení a vyložení věcí musí řidič odstavit motorové vozidlo na parkoviště.
              </p>
              <p className="text-red-600 font-bold my-3 text-lg">
                ! TOTO USTANOVENÍ PLATÍ BEZ VÝJIMKY !
              </p>
              <p>
                V případě nerespektování tohoto ustanovení se řidič motorového vozidla vystavuje riziku pokuty, případně odtažení vozidla.
              </p>
            </div>

            {/* 3) */}
            <p>
              <span className="font-bold">3)</span> {rules[2]}
            </p>

            {/* 4) */}
            <p>
              <span className="font-bold">4)</span> {rules[3]}
            </p>

            {/* 5) */}
            <p>
              <span className="font-bold">5)</span> {rules[4]}
            </p>

            {/* 6) */}
            <p>
              <span className="font-bold">6)</span> {rules[5]}
            </p>

            {/* 7) */}
            <p>
              <span className="font-bold">7)</span> {rules[6]}
            </p>

            {/* 8) - s červeným "zakázáno" */}
            <p>
              <span className="font-bold">8)</span> Volné pobíhání a venčení psů v areálu tábořiště je{' '}
              <span className="text-red-600 font-bold">zakázáno</span>.
            </p>

            {/* 9) - s červeným časem */}
            <p>
              <span className="font-bold">9)</span> Návštěvník areálu je povinen dodržovat noční klid{' '}
              <span className="text-red-600 font-bold">od 22.00 hod. do 6.00. hod.</span>
            </p>

            {/* 10) */}
            <p>
              <span className="font-bold">10)</span> {rules[9]}
            </p>
          </div>

          {/* Závěr - červeně */}
          <div className="border-t border-gray-300 mt-8 pt-8 space-y-2">
            <p className="text-red-600 font-bold text-lg">
              V případě, kdy je stánek s občerstvením uzavřen, informujte se na tel:{' '}
              <a href="tel:604205029" className="hover:underline">604205029</a>
            </p>
            <p className="text-red-600 font-bold text-lg">
              Přejeme Vám příjemný pobyt.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProvozniRad;
